"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPointerEventTypeNames = exports.EPointerEventType = void 0;
/**
 * @public
 * Supported pointer events (both mouse and touch events).
 */
var EPointerEventType;
(function (EPointerEventType) {
    EPointerEventType[EPointerEventType["Move"] = 0] = "Move";
    EPointerEventType[EPointerEventType["Up"] = 1] = "Up";
    EPointerEventType[EPointerEventType["Down"] = 2] = "Down";
    EPointerEventType[EPointerEventType["Out"] = 3] = "Out";
})(EPointerEventType = exports.EPointerEventType || (exports.EPointerEventType = {}));
/**
 * @internal
 */
class EPointerEventTypeNames {
}
exports.EPointerEventTypeNames = EPointerEventTypeNames;
_a = EPointerEventType.Move, _b = EPointerEventType.Up, _c = EPointerEventType.Down, _d = EPointerEventType.Out;
EPointerEventTypeNames[_a] = "Mouse move";
EPointerEventTypeNames[_b] = "Mouse up";
EPointerEventTypeNames[_c] = "Mouse down";
EPointerEventTypeNames[_d] = "Mouse out";
//# sourceMappingURL=e-pointer-event-type.js.map